import React from 'react';

import { Product } from '@src/core/buyerApiClient';
import PlaceholderImage from '@src/components/ui2/PlaceholderImage';
import { Wrapper } from './styles';

interface Props {
  product: Product;
  showPlaceholderImage?: boolean;
}

export const ProductImage = (props: Props) => {
  const { product, showPlaceholderImage = false } = props;

  return (
    <>
      {product.thumbnailUrl ? (
        <Wrapper>
          <img src={product.thumbnailUrl} alt={product.name} />
        </Wrapper>
      ) : showPlaceholderImage ? (
        <Wrapper>
          <PlaceholderImage />
        </Wrapper>
      ) : null}
    </>
  );
};

export default ProductImage;
